import { render, staticRenderFns } from "./sessions-home.vue?vue&type=template&id=aef9d23c&"
import script from "./sessions-home.vue?vue&type=script&lang=js&"
export * from "./sessions-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports